import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);  // Scroller vers le haut de la page
    }, [pathname]);

    return null;  // Ce composant n'affiche rien, il ne fait que gérer le scroll
};

export default ScrollToTop;
